import { ZPlayNetworkService } from "../commons/zplay-network-service";

import jwt_decode from "jwt-decode";
import {UserRole} from "../models";

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class AuthenticationService {

    public static isNotAdmin = (): boolean => {

        let token = localStorage.getItem(ZPlayNetworkService.TOKEN_KEY);

        if (!token) {
            return false;
        }

        let decoded: any = jwt_decode(token);

        if (!decoded) {
            return false;
        }

        return decoded["custom:role"] !== UserRole.ADMIN;
    };

    public static isNotAtLeastProducer = (): boolean => {

        let token = localStorage.getItem(ZPlayNetworkService.TOKEN_KEY);

        if (!token) {
            return false;
        }

        let decoded: any = jwt_decode(token);

        if (!decoded) {
            return false;
        }
        return decoded["custom:role"] !== UserRole.ADMIN && decoded["custom:role"] !== UserRole.PRODUCER && decoded["custom:role"] !== UserRole.CHIEF_PRODUCER;
    };

    public static isNotAtLeastChiefProducer = (): boolean => {

        let token = localStorage.getItem(ZPlayNetworkService.TOKEN_KEY);

        if (!token) {
            return false;
        }

        let decoded: any = jwt_decode(token);

        if (!decoded) {
            return false;
        }
        return decoded["custom:role"] !== UserRole.ADMIN  && decoded["custom:role"] !== UserRole.CHIEF_PRODUCER;
    };


    public static isExpired = (): boolean => {

        let token = localStorage.getItem(ZPlayNetworkService.TOKEN_KEY);

        if (!token) {
            return false;
        }

        let decoded: any = jwt_decode(token);

        if (!decoded) {
            return false;
        }

        let currentTs = new Date().getTime();

        if (currentTs >= (decoded.exp * 1000)) {
            return true; //FIXME: try refresh
        }

        return false;
    };

    public static isLoggedIn = (): boolean => {

        let token = localStorage.getItem(ZPlayNetworkService.TOKEN_KEY);

        if (!token) {
            return false;
        }

        let decoded: any = jwt_decode(token);

        if (!decoded) {
            return false;
        }

        let currentTs = new Date().getTime();

        if (currentTs >= decoded.exp * 1000) {
            return false; //FIXME: try refresh
        }

        return true;
    };



    public static getLocalCurrentUser = () => {

        let currentUser = localStorage.getItem("current_user");

        if (!currentUser || this.isExpired())
            return null

        if (currentUser)
            return JSON.parse(currentUser);
    };

    public static updateCurrentUserWithPromise = async () => {

        let user = await ZPlayNetworkService.promiseGet(`${API_BASE_URL}/api/users/current`);

        localStorage.setItem("current_user", JSON.stringify(user));

    };

    public static getCurrentUser = (successCallback: any, errorCallback: any) => {
        ZPlayNetworkService.get(`${API_BASE_URL}/api/users/current`, successCallback, errorCallback);
    };

    public static login = (loginRequest: any, callback: any, errCallback: any) => {
        ZPlayNetworkService.unauthorizedPost(`${API_BASE_URL}/api/users/login`, loginRequest, callback, errCallback);
    };

    public static logout = (callback: any, errCallback: any) => {
        ZPlayNetworkService.postEmptyResponse(`${API_BASE_URL}/api/users/logout`,{}, callback, errCallback);
    };

    public static register = (registerUserRequest: any, callback: any, errCallback: any) => {

        ZPlayNetworkService.unauthorizedPostEmptyResponse(`${API_BASE_URL}/api/users/`, registerUserRequest, callback,
            errCallback);
    };

    public static confirm = (confirmUserRequest: any, callback: any, errCallback: any) => {

        ZPlayNetworkService.unauthorizedPutEmptyResponse(`${API_BASE_URL}/api/users/confirm`, confirmUserRequest,
            callback, errCallback);
    };
}
